import { styled } from '@mui/material';

export const StyledSentences = styled('div')`
  max-width: 592px;
  margin-left: auto;
  margin-right: auto;
  margin-top: -48px;
`;

export const StyledRecordTime = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  gap: 2px;
  height: 32px;
  gap: 8px;
  opacity: 1;
  border-radius: 480px;
  padding-top: 4px;
  padding-right: 8px;
  padding-bottom: 4px;
  padding-left: 8px;
  box-sizing: border-box;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;
